import(/* webpackMode: "eager" */ "/repo/apps/web/src/app/global-error.tsx");
